<mat-dialog-content class="electronic-disclosure">
	<button class="o-modal-dismiss">
		<epi-icon
			mat-dialog-close
			use="close"
			size="24"
		></epi-icon>
	</button>
	<epi-heading
		level="2"
		appears-as="1"
		color="primary"
	>
		Electronic Delivery Disclosure and Consent
	</epi-heading>
	<p class="electronic-disclosure__content u-margin-top-small">
		By clicking Purchase Policy, you agree that all policy documents, endorsement documents, notices and communications
		regarding this policy, other than documents required to be delivered by another method, may be delivered to you by
		electronic mail using the email associated with your account.
	</p>
	<p class="electronic-disclosure__content u-margin-top-small">
		You may withdraw your consent to receive electronic documents and request paper documents by mail at any time by
		contacting Embrace and making that request. There is no charge to receive paper documents.
	</p>
	<p class="electronic-disclosure__content u-margin-top-small">
		You understand that to receive documents electronically, you need to have a personal computer with internet
		connectivity and a device capable of accessing portable document files (PDF), Adobe 5 or higher and one of the
		following; Internet Explorer 10.0* or higher, Microsoft Edge, Firefox 27 or higher, Chrome 38 or higher, Safari 7 or
		higher. We will provide notice to you in the event of any changes regarding hardware or software requirement
		necessary to receive Policy Documents and other related documents electronically.
	</p>
	<p class="electronic-disclosure__content u-margin-top-small">
		You agree to notify us if your email address, mailing address or other delivery information changes by contacting
		customer care hello@embracepetinsurance.com or 800-511-9172.
	</p>
</mat-dialog-content>
